import React from 'react'

import {Honeybadger} from '@honeybadger-io/react'

const {honeybadger: config} = window.Config

if (!config) {
  console.error('Honeybadger config not set')
}

export const honeybadger = Honeybadger.configure(config)

const HoneyBadgerContext = React.createContext(honeybadger)

export default HoneyBadgerContext
